import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-droplet",
  "use": "icon-droplet-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-droplet\"><path d=\"M512 1024C300 1024 128 852 128 640 128 457.6 388.4 115.4 461.2 23.4c12-15 29.8-23.4 49-23.4h3.6c19.2 0 37 8.4 49 23.4C635.6 115.4 896 457.6 896 640c0 212-172 384-384 384zM320 672c0-17.6-14.4-32-32-32s-32 14.4-32 32c0 123.8 100.2 224 224 224 17.6 0 32-14.4 32-32s-14.4-32-32-32c-88.4 0-160-71.6-160-160z\" p-id=\"6731\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol